<template>
<div class="vliveInfo bgc box-shadow">
    <vliveHeader :item="item"></vliveHeader>
    <div class="padding-20 info-box">
        <div class="tips_box">
            <p>直播小贴士：一场最简单的直播需经过创建直播、推流、分享观看三个步骤，现在您已经成功创建了一场直播，下面快去推流吧！</p>
            <p>推荐您免费使用OBS视频直播软件<span @click="openPage('https://obsproject.com/zh-cn')" class="span_cursor">立即下载</span><span> ｜ </span><span @click="openPage('https://jingyan.baidu.com/article/f79b7cb30521089144023e1a.html')" class="span_cursor">使用教程</span></p>
        </div>
        <div class="classes blod">直播方式</div>
        <div class="liveWayBox">
            <div class="wayItem">
                <div class="itemLeft">
                    <img class="wayIcon" :src="require('@/common/images/cms/mobile_live.png')" alt="">
                    <div class="textMsg">
                        <div class="name">手机直播</div>
                        <div class="desp">使用手机 APP 采集并推流进行直播</div>
                    </div>
                </div>
                <div class="itemRight">
                    <el-button class="android" @click="openAppDownloadDialog('https://img.capwhale.com/download/capwhale_android_common.apk')">Android版</el-button>
                    <el-button class="ios" @click="openAppDownloadDialog('https://itunes.apple.com/cn/app/id1570226796?mt=8')">iOS版</el-button>
                </div>
            </div>
            <div class="wayItem">
                <div class="itemLeft">
                    <img class="wayIcon" :src="require('@/common/images/cms/web_live.png')" alt="">
                    <div class="textMsg">
                        <div class="name">培训直播</div>
                        <div class="desp">通过直播将电脑桌面或 ppt、pdf 等文档共享给学员&观众</div>
                    </div>
                </div>
                <div class="itemRight">
                    <el-button class="openWebLive" @click="openWebLive">打开网页版</el-button>
                </div>
            </div>
            <div class="wayItem">
                <div class="itemLeft">
                    <img class="wayIcon" :src="require('@/common/images/cms/self_live.png')" alt="">
                    <div class="textMsg">
                        <div class="name">自定义推流设备</div>
                        <div class="desp">支持使用任何具备rtmp推流功能的设备或软件进行直播，如OBS、摄像机、照相机等，OBS <span  @click="openPage('https://obsproject.com/zh-cn')" class="span_cursor">下载地址</span><span class="line"> | </span><span @click="openPage('https://jingyan.baidu.com/article/f79b7cb30521089144023e1a.html')" class="span_cursor">使用教程</span></div>
                    </div>
                </div>
                <div class="itemRight">
                    <el-button class="copyAddress" v-clipboard:copy="item.pushurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制推流地址</el-button>
                </div>
            </div>
        </div>
        <div class="classes blod">直播控制台</div>
        <div class="step-list">
            <div class="step" :class="[item.streamstatus ==0?'is-active':(item.streamstatus==1?'sel':(item.streamstatus==2?'sel':''))]">
                <div class="title">1 未开始</div>
                <div class="pentagon">
                    <span></span>
                </div>
            </div>
            <div class="step" :class="[item.streamstatus==1?'is-active':(item.streamstatus==10?'sel':'')]" v-if="item.streamstatus==1">
                <div class="title">2 直播中</div>
                <div class="pentagon">
                    <span></span>
                </div>
            </div>
            <div class="step" :class="[item.streamstatus==2?'is-active':(item.streamstatus==10?'sel':'')]" v-else>
                <div class="title">2 直播中</div>
                <div class="pentagon">
                    <span></span>
                </div>
            </div>
            <div class="step" :class="[item.streamstatus==10?'is-active':'']">
                <div class="title">3 直播结束</div>
            </div>
        </div>
        <div class="step-content">
            <div class="step-content-1" v-if="item.streamstatus==0">
                <div class="plug-flow-list">
                    <div v-show="visible" class="box">
                        <div class="plug-flow-info">
                            <span class="name">推流服务器（URL）：</span>
                            <span class="value"><input type="text" v-model="item.fmsurl" readonly></span>
                            <el-button class="btn" type="text" size="small" v-clipboard:copy="item.fmsurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                        </div>
                        <div class="plug-flow-info">
                            <span class="name">推流串流密码：</span>
                            <span class="value"><input type="text" v-model="item.streamCluster" readonly></span>
                            <el-button class="btn" type="text" size="small" v-clipboard:copy="item.streamCluster" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                        </div>
                    </div>
                </div>
                <div class="plug-flow-status">
                    <!-- <div class="status">尚未进行推流</div> -->
                    <el-button type="danger" @click="handleEnd">结束直播</el-button>
                </div>
            </div>
            <div class="step-content-2" v-if="item.streamstatus==1">
                <div class="plug-flow-list">
                    <div v-show="visible" class="box">
                        <div class="plug-flow-info">
                            <span class="name">推流服务器（URL）：</span>
                            <span class="value"><input type="text" v-model="item.fmsurl" readonly></span>
                            <el-button class="btn" type="text" size="small" v-clipboard:copy="item.fmsurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                        </div>
                        <div class="plug-flow-info">
                            <span class="name">推流串流密码：</span>
                            <span class="value"><input type="text" v-model="item.streamCluster" readonly></span>
                            <el-button class="btn" type="text" size="small" v-clipboard:copy="item.streamCluster" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                        </div>
                    </div>
                    <div class="slide-btn" @click="visible=!visible"><span :class="[visible?'el-icon-d-arrow-left':'el-icon-d-arrow-right']"></span></div>
                    <div class="box" v-show="!visible">
                        <div class="plug-flow-info abnormal">
                            <span class="name">
                                <div class="tc-grey">推流状态</div>
                                <div>正在推流，测速中……</div>
                            </span>
                            <span class="value"><i class="icon icon_vlive"></i></span>
                            <span class="btn"></span>
                        </div>
                    </div>
                </div>
                <div class="plug-flow-status">
                    <el-button type="danger" @click="handleEnd">结束直播</el-button>
                </div>
            </div>
            <div class="step-content-2" v-if="item.streamstatus==2">
                <div class="plug-flow-list">
                    <div v-show="visible" class="box">
                        <div class="plug-flow-info">
                            <span class="name">推流服务器（URL）：</span>
                            <span class="value"><input type="text" v-model="item.fmsurl" readonly></span>
                            <el-button class="btn" type="text" size="small" v-clipboard:copy="item.fmsurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                        </div>
                        <div class="plug-flow-info">
                            <span class="name">推流串流密码：</span>
                            <span class="value"><input type="text" v-model="item.streamCluster" readonly></span>
                            <el-button class="btn" type="text" size="small" v-clipboard:copy="item.streamCluster" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                        </div>
                    </div>
                    <div class="slide-btn" @click="visible=!visible"><span :class="[visible?'el-icon-d-arrow-left':'el-icon-d-arrow-right']"></span></div>
                    <div v-show="!visible" class="box">
                        <div class="plug-flow-info normal">
                            <span class="name">直播信号中断</span>
                            <span class="value"><i class="icon icon_danger"></i>请检查直播设备是否正常工作！</span>
                            <span class="btn"></span>
                        </div>
                    </div>
                </div>
                <div class="plug-flow-status">
                    <el-button type="danger" @click="handleEnd">结束直播</el-button>
                </div>
            </div>
            <div class="step-content-3" v-if="item.streamstatus==10">
                直播已结束
            </div>
        </div>
        <div class="classes blod">观看地址</div>
        <div class="watchAddr">
            <div class="left">
                <img :src="wxQrCode" alt="">
                <div class="tc-grey tip">使用微信扫一扫</div>
            </div>
            <div class="right">
                <div class="gkdz_div">
                    <div class="watchUrl">
                        <div class="name">观看地址：</div><el-input v-model="item.hdPlayUrl" disabled></el-input>
                    </div>
                    <el-button class="copy" type="text" size="small" v-clipboard:copy="item.hdPlayUrl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                    <el-button type="text" size="small" @click="openPage(item.hdPlayUrl)">观看</el-button>
                </div>
                <div>
                    <!--<el-button type="text">观看</el-button>-->
                </div>
            </div>
        </div>
        <!--<div class="classes blod">小程序观看地址</div>-->
        <!--<div class="watchAddr">-->
            <!--<div class="left">-->
                <!--<img src="http://i2.sinaimg.cn/dy/c/2014-07-18/1405623657_VbFlfN.jpg" alt="">-->
                <!--<div class="tc-grey tip">使用微信扫一扫</div>-->
            <!--</div>-->
            <!--<div class="right">-->
                <!--<div><span class="name">小程序地址：</span><span class="tc-grey">{{item.xcxShowUrl }}</span></div>-->
                <!--<div>-->
                    <!--<el-button type="text" size="small" v-clipboard:copy="item.xcxShowUrl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
        <div v-if="item.streamstatus!=10">
        <div class="classes blod">推流地址</div>
        <div class="watchAddr">
            <div class="right">
                <div class="urlBox">
                    <div class="name">RTMP推流地址：</div>
                    <el-input disabled v-model="item.pushurl"></el-input>
                    <!-- <span class="tc-grey">{{item.pushurl}}</span> -->
                    <el-button type="text" size="small" v-clipboard:copy="item.pushurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                </div>
            </div>
        </div>
        <div class="classes blod">拉流地址</div>
        <div class="watchAddr">
            <div class="right">
                <div class="urlBox">
                    <div class="name">RTMP拉流地址：</div>
                    <el-input disabled v-model="item.pullurl"></el-input>
                    <!-- <span class="tc-grey">{{item.pullurl}}</span> -->
                    <el-button type="text" size="small" v-clipboard:copy="item.pullurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                </div>
            </div>
        </div>
        <div class="classes blod">播流地址</div>
        <div class="watchAddr">
            <div class="right">
                <div class="urlBox">
                    <div class="name">播流地址：</div>
                    <el-input disabled v-model="item.playurl"></el-input>
                    <!-- <span class="tc-grey">{{item.playurl}}</span> -->
                    <el-button type="text" size="small" v-clipboard:copy="item.playurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                </div>
            </div>
        </div>
        </div>
    </div>
    <el-dialog class="appDownloadDialog" title="直播下载" :visible.sync="dialogVisible" width="304px" :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="appDownloadDialogContent">
            <div class="codeBox">
                <img class="code" :src="appDownloadCode" alt="">
                <div class="desp">扫一扫下载</div>
            </div>
            <div class="urlCopy">
                <el-input v-model="appDownloadUrl" disabled></el-input>
                <el-button type="primary" v-clipboard:copy="appDownloadUrl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
            </div>
        </div>
    </el-dialog>
</div>
</template>

<script>
import VliveHeader from 'views/cms/vlive/components/vliveHeader'
import {getVliveAddr, endVliveAddr, getVliveStreamStatus} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
import {urlToQRCode} from 'common/js/tools'
import {vliveMsg} from 'api/message'
export default {
    name: 'vliveInfo',
    data() {
        return {
            type: 1,
            visible: true,
            url: 'http',
            item: {
                assetinnerid: this.$route.query.id ? this.$route.query.id : '' // id
            },
            wxQrCode: '',
            timer: null,
            dialogVisible: false,
            appDownloadCode: '',
            appDownloadUrl: ''
        }
    },
    mounted() {
        this._getView()
        let _this = this
        this.timer = setInterval(() => {
            _this._getVliveStatus()
        }, 10000)
    },
    methods: {
        openPage(url) {
            window.open(url)
        },
        _getVliveStatus() {
            getVliveStreamStatus({
                data: {
                    assetinnerid: this.item.assetinnerid
                },
                success: data => {
                    if (this.item.streamstatus === 10) {
                        clearInterval(this.timer)
                    }
                    this.item.streamstatus = data.data.streamstatus
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        handleEnd() {
            this.$prompt('<span class="tc-grey">' + vliveMsg.endVlive.msg + '</span>', vliveMsg.endVlive.title, {
                dangerouslyUseHTMLString: true,
                confirmButtonText: vliveMsg.endVlive.confirmText,
                cancelButtonText: vliveMsg.endVlive.cancelText
            }).then(({value}) => {
                endVliveAddr({
                    data: {
                        assetinnerid: this.item.assetinnerid
                    },
                    success: data => {
                        this.item.streamstatus = 10
                        clearInterval(this.timer)
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        onCopy(e) {
            this.$message({
                message: '复制成功',
                type: 'success'
            })
        },
        onError(e) {
            alert('失败')
        },
        _getView() {
            this.setLoading(true)
            getVliveAddr({
                data: {
                    assetinnerid: this.item.assetinnerid
                },
                success: data => {
                    this.item = data.data
                    this.wxQrCode = urlToQRCode(this.item.hdPlayUrl)
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 打开APP下载二维码弹窗
        openAppDownloadDialog(url) {
            this.appDownloadUrl = url
            this.appDownloadCode = urlToQRCode(url)
            this.dialogVisible = true
        },
        handleClose() {
            this.dialogVisible = false
            this.appDownloadCode = ''
            this.appDownloadUrl = ''
        },
        openWebLive() {
            if (this.$route.query.id) {
                window.open(window.origin + '/cms/vlive/webLive?id=' + this.$route.query.id)
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'loading'
        ])
    },
    components: {
        VliveHeader
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveInfo {
    .info-box {
        .tips_box {
            background-color: #F5F7FA;
            padding: 12px 20px;
            &>p {
                line-height: 24px;
                span {
                    color: #409EFF;
                }
                span:nth-of-type(1) {
                    margin-left: 20px;
                }
                .span_cursor:hover {
                    cursor: pointer;
                    color: rgb(17, 130, 243);
                }
            }
        }
        .liveWayBox {
            border: 1px solid #DCDFE6;
            .wayItem {
                padding: 34px 16px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                &:not(:last-of-type) {
                    border-bottom: 1px solid #DCDFE6;
                }
                .itemLeft {
                    display: flex;
                    align-items: center;
                    .wayIcon {
                        width: 48px;
                        height: 48px;
                        margin-right: 16px;
                    }
                    .textMsg {
                        .name {
                            font-size: 16px;
                            color: #303133;
                            margin-bottom: 4px;
                            line-break: 20px;
                            color: #303133;
                        }
                        .desp {
                            font-size: 14px;
                            color: #909399;
                            line-break: 20px;
                            .span_cursor {
                                cursor: pointer;
                                color: #409EFF;
                            }
                            .line {
                                color: #409EFF;
                            }
                        }
                    }
                }
                .itemRight {
                    .android {
                        width: 106px;
                        height: 36px;
                        color: #909399;
                        &:hover {
                            color: #409EFF;
                        }
                    }
                    .ios {
                        min-width: 78px;
                        width: 78px;
                        height: 36px;
                        color: #909399;
                        &:hover {
                            color: #409EFF;
                        }
                    }
                    .openWebLive {
                        width: 110px;
                        background: #409EFF;
                        color: #fff;
                        border-color: #409EFF;
                        height: 36px;
                    }
                    .copyAddress {
                        width: 124px;
                        color: #909399;
                        height: 36px;
                        &:hover {
                            color: #409EFF;
                        }
                    }
                }
            }
        }
        .step-list {
            @include flexBox(space-between);
            border-right: 1px solid $line;
            border-left: 1px solid $line;
            .step {
                border-top: 1px solid $line;
                border-bottom: 1px solid $line;
                flex-grow: 1;
                @include flexBox(space-between);
                .title {
                    flex-grow: 1;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    color: $tcolor-grey;
                    background: $bgcolor-white;
                }
                .pentagon {
                    width: 0;
                    height: 0;
                    border-left: 10px solid $line;
                    border-bottom: 20px solid transparent;
                    border-top: 20px solid transparent;
                    position: relative;
                    span {
                        display: block;
                        width: 0;
                        height: 0;
                        border-left: 9px solid $bgcolor-white;
                        border-bottom: 19px solid transparent;
                        border-top: 19px solid transparent;
                        position: absolute;
                        left: -10px;
                        top: -19px;
                    }
                }
            }
            .is-active .title {
                background: $bgcolor-base;
                color: $tcolor-white;
            }
            .is-active .pentagon {
                span {
                    border-left-color: $bgcolor-base;
                }
            }
        }
        .step-content {
            box-sizing: border-box;
            height: 134px;
            border: 1px solid $line;
            .plug-flow-list {
                @include flexBox(space-between);
                line-height: 46px;
                flex-grow: 1;
                overflow: hidden;
                .box {
                    padding: 20px;
                    flex-grow: 1;
                }
                .plug-flow-info {
                    @include flexBox(space-between);
                    .name {
                        width: 160px;
                        flex-grow: 0;
                    }
                    .value {
                        flex-grow: 1;
                        input{
                            width: 100%;
                            height: 36px;
                            padding: 0 5px;
                            box-sizing: border-box;
                            border: 1px solid $line;
                            border-radius: 5px;
                        }
                    }
                    .btn {
                        flex-grow: 0;
                        margin-right: 220px;
                    }
                }
            }
            .plug-flow-status {
                width: 250px;
                text-align: center;
            }
            .step-content-1 {
                @include flexBox(space-between);
                .status {
                    height: 60px;
                    border-left: 2px solid $line;
                    line-height: 60px;
                }
            }
            .step-content-2 {
                @include flexBox(space-between);
                .status {
                    height: 60px;
                    border-left: 2px solid $line;
                    line-height: 60px;
                }
                .slide-btn {
                    width: 30px;
                    background: $bgcolor-lightgrey;
                    height: 132px;
                    line-height: 132px;
                    text-align: center;
                    color: $tcolor-grey;
                }
                .normal {
                    .icon {
                        width: 40px;
                        height: 34px;
                        margin-right: 10px;
                    }
                    .name {
                        width: 250px;
                        flex-grow: 1;
                    }
                    .value {
                        flex-grow: 1;
                        @include flexBox(flex-start);
                    }
                }
                .abnormal {
                    .icon {
                        width: 88px;
                        height: 70px;
                    }
                    .name {
                        width: 250px;
                        text-align: center;
                        flex-grow: 0;
                        div {
                            height: 30px;
                            line-height: 30px;
                        }
                    }
                    .value {
                        flex-grow: 1;
                        @include flexBox(center);

                    }
                }
            }
            .step-content-3 {
                @include flexBox(center);
                margin-top: 60px;
            }
        }
        .sel {
            background: $bgcolor-base;
        }
        .watchAddr {
            @include flexBox(flex-start);
            .left {
                margin-right: 100px;
                img {
                    width: 150px;
                    height: 150px;
                }
                .tip {
                    margin: 15px 0;
                    text-align: center;
                }
            }
            .right {
                div {
                    margin-bottom: 20px;
                }
                span {
                    margin-right: 10px;
                }
                .btn {
                    margin-right: 30px;
                }
                .urlBox {
                    display: flex;
                    align-items: center;
                    margin-bottom: 0;
                    .name {
                        white-space: nowrap;
                        margin-right: 20px;
                        margin-bottom: 0;
                    }
                    .el-input {
                        margin-bottom: 0;
                        width: 500px;
                        &.is-disabled {
                            .el-input__inner {
                                background: #fff;
                                cursor: default;
                            }
                        }
                    }
                }
                .gkdz_div {
                    .watchUrl {
                        display: flex;
                        align-items: center;
                        margin-bottom: 0;
                        .name {
                            width: 80px;
                            min-width: 80px;
                        }
                        .el-input {
                            width: 500px;
                            &.is-disabled {
                                .el-input__inner {
                                    background: #fff;
                                    cursor: default;
                                }
                            }
                        }
                    }
                    .el-button {
                        margin-left: 10px;
                        width: 50px;
                        min-width: 50px;
                    }
                    .el-button + .el-button {
                        margin-left: 0;
                    }
                    .copy {
                        margin-left: 0;
                        text-align: left;
                    }
                }
            }
        }
    }
    .classes{
        margin-top: 20px;
    }
    .appDownloadDialog {
        .el-dialog {
            .el-dialog__header {
                padding: 15px 20px;
            }
            .el-dialog__body {
                .appDownloadDialogContent {
                    .codeBox {
                        margin-bottom: 20px;
                        text-align: center;
                        .code {
                            width: 134px;
                            height: 134px;
                        }
                        .desp {
                            font-size: 14px;
                            color: #303133;
                        }
                    }
                    .urlCopy {
                        display: flex;
                        align-content: center;
                        .el-input {
                            width: 210px;
                            border-radius: 4px 0 0 4px;
                            height: 34px;
                            &.is-disabled {
                                .el-input__inner {
                                    height: 34px;
                                    border-radius: 4px 0 0 4px;
                                    cursor: default;
                                    padding-right: 5px;
                                    background: #fff;
                                }
                            }
                        }
                        .el-button {
                            width: 54px;
                            height: 34px;
                            min-width: 54px;
                            border-radius: 0 4px 4px 0;
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }
    }
}
</style>
